<template>
  <div class="news-item" v-if="dataList.status != -1">
    <h1>
      <template v-if="myList">
        <span class="status d-status fl" v-if="dataList.status == 0"
          >待审核</span
        >
        <span class="status w-status fl" v-if="dataList.status == 2"
          >未通过</span
        >
      </template>
      <a class="fl" :href="'/detail/' + dataList.id + '/0'" target="_blank">{{
        dataList.title
      }}</a>
      <div class="fr cz-btn" v-if="myList">
        <i class="el-icon-more" @click="addTypeFlag = !addTypeFlag"></i>
        <ul class="classtify" v-show="addTypeFlag">
          <li @click="deleArticle(dataList.id)">删除</li>
          <li @click="editArticle(dataList.id,dataList.type)">重新编辑</li>
        </ul>
      </div>
    </h1>
    <div
      v-if="dataList.imgStr.length == 3"
      class="item-imgs"
    >
      <img v-for="(item, i) in dataList.imgStr" :key="i" :src="item" alt="" />
    </div>
    <div v-else-if="dataList.imgStr.length > 0" class="item-img-des">
      <img :src="dataList.imgStr[0]" alt="" />
      <p>
        {{ dataList.summary }}
      </p>
    </div>
    <div v-else class="item-des">
      <p>
        {{ dataList.summary }}
      </p>
    </div>
    <div v-if="dataList.videoUrl" class="item-video">
      <iframe width="520" height="300"
        :src="'https://player.dahe.cn/dh_player/?videosrc='+ dataList.videoUrl"
        frameborder="0" allowfullscreen>
      </iframe>
    </div>
    <div class="item-topic" v-if="dataList.topicName&&!isTopic">
      <p><a :href="'/topic/'+dataList.topicId" target="_blank">{{ dataList.topicName }}</a></p>
    </div>
    <div class="item-footer">
      <div class="user-name" @click="userCenter(dataList.userId)">
        <img
          :src="dataList.userIcon||'/static/img/mr-usericon.png'"
          alt=""
        />
        {{ dataList.userName }}
      </div>
      <span class="ml20">
        <i class="el-icon-pubtime"></i>{{ dataList.formatTime }}
      </span>
      <span class="ml20">
        <i class="el-icon-look"></i>{{ dataList.pvStr }}
      </span>
      <span class="ml20">
        <i class="el-icon-chat"></i>{{ dataList.discussNum }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "hotPost",
  props: ["dataList", "myList",'isTopic'],
  data() {
    return {
      addTypeFlag: false
    };
  },
  methods: {
    deleArticle(id) {
      this.$confirm("此操作将永久删除该文章, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$api
            .articleDel({
              id: id,
            })
            .then((res) => {
              this.$message.success("删除成功!");
              this.dataList.status = -1;
            });
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },
    userCenter(id) {
      this.$router.push("/usercenter/" + id);
    },
    editArticle(id,type) {
      this.$router.push("/user/"+ (type==1?'video':'posts') +"/edit?id=" + id);
    },
  },
};
</script>

<style scoped lang="scss">
.news-item {
  padding: 24px 24px 20px;
  border-bottom: 1px solid #efefef;
  h1 {
    font-size: 18px;
    line-height: 25px;
    height: 27px;
    position: relative;
    display: block;
    width: 100%;
    a {
      color: #121212;
      display: block;
      width: calc(100% - 90px);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    margin-bottom: 14px;
    .channel-name {
      height: 16px;
      line-height: 16px;
      color: #fff;
      font-size: 12px;
      background: #589bff;
      padding: 1px 1px 1px 5px;
      border-radius: 2px;
      position: relative;
      margin-right: 10px;
      float: left;
      margin-top: 4px;
      font-weight: 500;
      &::after {
        content: "";
        color: #fff;
        position: absolute;
        top: -1.5px;
        right: -9px;
        width: 0;
        height: 0;
        border-width: 10px 0 10px 10px;
        border-style: solid;
        border-color: transparent transparent transparent #589bff;
      }
    }
    .channel-jd {
      background: #589bff;
      &::after {
        border-color: transparent transparent transparent #589bff;
      }
    }
    .channel-zt {
      background: #62D89A;
      &::after {
        border-color: transparent transparent transparent #62D89A;
      }
    }
    .channel-lt {
      background: #BFCA81;
      &::after {
        border-color: transparent transparent transparent #BFCA81;
      }
    }
    .channel-pk {
      background: #F9A25F;
      &::after {
        border-color: transparent transparent transparent #F9A25F;
      }
    }
    .channel-qy {
      background: #6CAF80;
      &::after {
        border-color: transparent transparent transparent #6CAF80;
      }
    }
    .channel-js {
      background: #FCAB4E;
      &::after {
        border-color: transparent transparent transparent #FCAB4E;
      }
    }
    .channel-lx {
      background: #5DC8E6;
      &::after {
        border-color: transparent transparent transparent #5DC8E6;
      }
    }
    .channel-gy {
      background: #FB8175;
      &::after {
        border-color: transparent transparent transparent #FB8175;
      }
    }
    .channel-sh {
      background: #A296FE;
      &::after {
        border-color: transparent transparent transparent #A296FE;
      }
    }
    .channel-qm {
      background: #F85A56;
      &::after {
        border-color: transparent transparent transparent #F85A56;
      }
    }
    .channel-hd {
      background: #E19369;
      &::after {
        border-color: transparent transparent transparent #E19369;
      }
    }
    .status {
      border-radius: 3px;
      font-size: 12px;
      font-weight: 400;
      line-height: 17px;
      padding: 5px 6px;
    }
    .d-status {
      background: #dcf3c9;
      color: #018439;
    }
    .w-status {
      background: #feecec;
      color: #317DFF;
    }
    .cz-btn {
      position: relative;
      z-index: 5;
      i {
        color: #d8d8d8;
        cursor: pointer;
      }
      .classtify {
        width: 100px;
        margin: 5px auto;
        box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.3);
        border-radius: 2px;
        color: #535353;
        padding: 10px 0;
        background: #fff;
        text-align: center;
        line-height: 2;
        position: absolute;
        top: 15px;
        left: -40px;
        li {
          font-size: 15px;
          cursor: pointer;
          &:hover {
            background: #f5f5f5;
            color: #317DFF;
          }
        }
      }
    }
  }
  .item-des{
    margin-bottom: 10px;
  }
  .item-imgs {
    display: flex;
    justify-content: space-between;
    img {
      width: 204px;
      height: 127px;
      border-radius: 4px;
    }
  }
  .item-img-des {
    display: flex;
    justify-content: space-between;
    img {
      width: 190px;
      height: 116px;
      border-radius: 5px;
    }
    p {
      width: 435px;
      padding-left: 10px;
      text-align: justify;
    }
  }
  p {
    color: #333333;
    font-size: 15px;
    line-height: 26px;
  }
  .item-topic{
    font-size: 14px;
    line-height: 26px;
    margin-top: 10px;
    a{
      color: #317DFF;
    }
  }
  .item-footer {
    margin-top: 10px;
    color: #999999;
    font-size: 13px;
    .user-name {
      cursor: pointer;
      float: left;
      font-size: 13px;
    }
    img {
      width: 24px;
      height: 24px;
      border-radius: 50%;
      vertical-align: middle;
      margin-right: 10px;
    }
    span{
      line-height: 24px;
    }
    i {
      font-size: 16px;
      vertical-align: bottom;
      margin-right: 6px;
      display: inline-block;
      width: 15px;
      height: 24px;
      &.el-icon-pubtime{
        width: 16px;
        background: url('../assets/images/icon/pubtime.png') center no-repeat;
      }
      &.el-icon-look{
        width: 18px;
        background: url('../assets/images/icon/look.png') center no-repeat;
      }
      &.el-icon-chat{
        background: url('../assets/images/icon/discuss.png') center no-repeat;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NewsList.vue